<div class="flex row p-2 justify-between">
    <div class="text-lg font-medium tracking-tight leading-6 truncate">
        Well Healthiness Historical Records
    </div>
    <div>
        <button mat-dialog-close>
            <ng-container [ngTemplateOutlet]="closedIcon"></ng-container>
        </button>
    </div>
</div>
<hr class="my-0">

<mat-dialog-content #pageContainer>

    <form [formGroup]="searchForm">
        <div class="flex justify-between items-center w-full mb-3">
            <div class="text-xl font-medium">
                {{ data.stringLongName ?? '' }}
            </div>
            <div class="flex justify-around">
                <div class="w-17 mx-2">
                    <mat-form-field class="w-full">
                        <mat-select formControlName="PageSize">
                            <mat-option [value]="10"> 10 </mat-option>
                            <mat-option [value]="20"> 20 </mat-option>
                            <mat-option [value]="50"> 50 </mat-option>
                            <mat-option [value]="100"> 100 </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <!-- <button class="btn btn-outline" matTooltip="Download" (click)="downloadEquipmentRegHistoricalRecords()">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                        stroke="currentColor" class="w-6 h-6">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3" />
                    </svg>
                </button> -->
            </div>
        </div>
    </form>

    <div class="grid overflow-x-auto">
        <!-- Header -->
        <div class="table-wh-historical-record-grid z-10 sticky top-0 grid shadow text-md font-semibold text-white bg-primary dark:bg-black dark:bg-opacity-5"
            matSort matSortDisableClear>

            <div class="border py-8 text-center">
                No
            </div>

            <div [mat-sort-header]="'wellHealthinessStatus'" class="flex border justify-center py-4">
                Well Healthiness Status
            </div>

            <div [mat-sort-header]="'riskRanking'" class="flex border justify-center py-4">
                Risk Ranking
            </div>

            <div [mat-sort-header]="'updateBy'" class="flex border justify-center py-4">
                Status Updated By
            </div>

            <div [mat-sort-header]="'status'" class="flex border justify-center py-4">
                Request Update Status
            </div>

            <div [mat-sort-header]="'approvedBy'" class="flex border justify-center py-4">
                Approved By
            </div>

            <div [mat-sort-header]="'approvedDate'" class="flex border justify-center py-4">
                Approved Date
            </div>

            <div [mat-sort-header]="'rejectedBy'" class="flex border justify-center py-4">
                Rejected By
            </div>

            <div [mat-sort-header]="'rejectedDate'" class="flex border justify-center py-4">
                Rejected Date
            </div>

            <div [mat-sort-header]="'remarks'" class="flex border justify-center py-4">
                Remark
            </div>
        </div>
        <!-- Rows -->
        <ng-container *ngIf="dt.rows.length; else noRecords">
            <ng-container *ngFor="let row of dt.rows; let i = index; trackBy: trackByFn;">
                <div class="table-wh-historical-record-grid grid items-center border-b">
                    <!-- No -->
                    <div class="py-4 text-center">
                        {{startingIndex + i + 1}}.
                    </div>

                    <!-- Well Healthiness Status -->
                    <div class="flex truncate justify-center" [ngClass]="{
                                'healthyBadge': row.wellHealthinessStatus?.toLowerCase() === 'healthy' || row.wellHealthinessStatus?.toLowerCase() === 'healthy with moc',
                                'unhealthyBadge': row.wellHealthinessStatus?.toLowerCase() === 'unhealthy' || row.wellHealthinessStatus?.toLowerCase() === 'unhealthy with moc',
                              }">
                        {{ row.wellHealthinessStatus || '-' }}
                    </div>

                    <!-- Risk Ranking  -->
                    <div class="block text-start mx-2 pl-4" [ngClass]="{
                                'risk0Badge': row.riskRanking?.toLowerCase() === 'healthy no risk',
                                'risk1Badge': row.riskRanking?.toLowerCase() === 'healthy low risk',
                                'risk2Badge': row.riskRanking?.toLowerCase() === 'healthy medium risk',
                                'risk3Badge': row.riskRanking?.toLowerCase() === 'unhealthy high risk',
                                'risk4Badge': row.riskRanking?.toLowerCase() === 'unhealthy very high risk',
                              }">
                        {{ row?.riskRanking ? row.scoringMatrix + ' - ' + row.riskRanking : '-' }}

                    </div>

                    <!-- Status Updated By  -->
                    <div class="flex justify-center">
                        {{ row.updateBy || '-' }}
                    </div>

                    <!-- Request Updated Status  -->
                    <div class="text-center mx-2" [ngClass]="{
                                'successBadge': row.status?.toLowerCase() === 'approved',
                                'failedBadge': row.status?.toLowerCase() === 'rejected',
                                'idleBadge': row.status?.toLowerCase() === 'modify/override',
                                'warningBadge': row.status?.toLowerCase() === 'ready to review' || row.status?.toLowerCase() === 'on hold'
                    }">
                        {{ row.status == "On Hold" ? "Ready to Review" : row.status || '-' }}
                    </div>

                    <!-- Approved By  -->
                    <div class="text-center">
                        {{ row.approvedBy || '-' }}
                    </div>

                    <!-- Approved Date  -->
                    <div class="text-center">
                        {{ row.approvedDate ? handleFormatDate(row.approvedDate, false) : '-' }}
                    </div>

                    <!-- Rejected By  -->
                    <div class="text-center">
                        {{ row.rejectedBy || '-' }}
                    </div>

                    <!-- Rejected Date  -->
                    <div class="text-center">
                        {{ row.rejectedDate ? handleFormatDate(row.rejectedDate, false) : '-' }}
                    </div>

                    <!-- Remark -->
                    <div class="block text-center">
                        {{ row.remarks || '-' }}
                    </div>
                </div>
            </ng-container>
        </ng-container>

        <ng-template #noRecords>
            <div class="p-8 sm:p-16 text-2xl sm:text-2xl font-semibold tracking-tight text-center">
                There are no records registered!
            </div>
        </ng-template>
    </div>

    <div
        class="flex justify-between inset-x-0 bottom-0 border-b border-t border-b-0 z-10 bg-gray-50 dark:bg-transparent">
        <div class="content-center px-3">
            {{ dt.page.totalRecords || 0 }} {{ dt.page.totalRecords <= 1 ? 'total' : 'totals' }} </div>

                <mat-paginator class="bg-gray-50" [ngClass]="{'pointer-events-none': isLoading}"
                    [length]="dt.page?.totalRecords" [pageIndex]="dt.page.offset" [pageSize]="dt.page.size"
                    [hidePageSize]="true" [showFirstLastButtons]="true" (page)="onPageChange($event)">
                </mat-paginator>
        </div>
</mat-dialog-content>

<ng-template #closedIcon>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
        class="w-6 h-6">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
    </svg>
</ng-template>